import {useColorMode} from '../../util/useColorMode';

const NIGHT_MODE_REVERT_FILTER =
  'brightness(80%) contrast(120%) hue-rotate(180deg) invert(100%)';

const NIGHT_MODE_FILTER =
  'invert(100%) hue-rotate(180deg) contrast(80%) brightness(120%)';

export function useNightModeRevertFilter(): string | undefined {
  const {isDarkMode} = useColorMode();
  return isDarkMode ? NIGHT_MODE_REVERT_FILTER : undefined;
}

/**
 * useNightModeFilter returns the page-level night-mode filter, for
 * light-authored markup nested inside a `@wandb/components` surface that
 * reverts that filter on itself. Mirrors the `night-aware-exclude-children`
 * LESS rule.
 */
export function useNightModeFilter(): string | undefined {
  const {isDarkMode} = useColorMode();
  return isDarkMode ? NIGHT_MODE_FILTER : undefined;
}
